import { useState } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
// Custom Components Imports
import HeroBanner from "../Other/HeroBanner";
// import LearningBeyond from "../Other/LearningBeyond";
import IndependenceDayOfferModal from "@/_components/model";
import ContactSales from "../Other/BookDemo/ContactSales";
import Notification from "../Other/BookDemo/Notification";
import Carousel from "../Other/Carousel/Carousel";
import Modal from "../Other/Modal";
import MostPopularCertificates from "../Other/MostPopularCertificates";
import ExploreProgramHome from "../Program/ExploreProgramHome";
import TrendingSearches from "../Program/TrendingSearches";
import OffersSection from "./OffersSection";
//Declarations
// const sections = `arts, automobiles, books, business, fashion, food, health,
// home, insider, magazine, movies, national, nyregion, obituaries,
// opinion, politics, realestate, science, sports, sundayreview,
// technology, theater, tmagazine, travel, upshot, world`
//     .replace(/ /g, "")
//     .split(",");

function HomePage() {
  //const [articles, setArticles] = useState([]);
  const articles = [];
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showContact, setShowContact] = useState(false);
  const [manageNotification, setManageNotification] = useState(false);
  const handleContactOpen = () => setShowContact(true);
  const handleContactClose = () => setShowContact(false);
  const [manageContactSalesModal, setManageContactSalesModal] = useState(false);

  const handleManageOverlay = (values) => {
    if (values) {
      setManageNotification(true);
    } else {
      setManageNotification(false);
    }
  };
  const handleContactSales = (value) => {
    setManageContactSalesModal(value);
  };
  const closeNotification = () => {
    setManageNotification(false);
  };
  // useEffect(() => {
  //   dispatch(courseActions.handleResetCourseList());
  //   dispatch(courseActions.fetchCourses());
  //   dispatch(userActions.getGeoLocation());
  //   // dispatch(courseActions.myCourses())
  // }, []);

  return (
    <main className="HomePage">

      <div>
        {/* Right side Contact button */}
        <button
          style={{
            position: "fixed",
            top: "300px",
            right: 0,
            zIndex: 1000,
            background: "linear-gradient(180deg, #2196f3 0%, #21cbf3 100%)", // linear gradient
            color: "#fff",
            border: "none",
            borderRadius: "8px 0 0 8px",
            padding: "12px 18px",
            cursor: "pointer",
            fontWeight: "bold",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            letterSpacing: "2px"
          }}
          onClick={handleContactOpen}
        >
          Contact
        </button>

        {/* Tailwind Modal */}
        {showContact && (
          <Modal isOpen={showContact} onClose={handleContactClose}>
            <div className="forms-width-55 add-page !bg-dark">
              {/* <div className="dashboard-container-new padding-custom-dashboard-0 bg-blue-500 p-8 text-lg text-white mb-5 rounded-xl">
                <p>Contact Sales</p>
              </div> */}
              <ContactSales
                closeHandler={handleContactClose}
                handleManageOverlay={handleManageOverlay}
                handleContactSales={handleContactSales}
              />
            </div>
          </Modal>
        )}
        {manageNotification ? (
          <Notification closeNotification={closeNotification} />
        ) : null}
        <div className="row">
          <div className="col right">
            {articles.map((a, i) => (
              <Card key={i}>
                <Card.Body>
                  <Card.Title>{a.title}</Card.Title>
                  <Card.Img
                    variant="top"
                    className="image"
                    src={
                      Array.isArray(a.multimedia) &&
                        a.multimedia[a.multimedia.length - 1]
                        ? a.multimedia[a.multimedia.length - 1].url
                        : null
                    }
                  />
                  <Card.Text>{a.abstract}</Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => (window.location.href = a.url)}
                  >
                    {t("Go")}
                  </Button>
                </Card.Body>
              </Card>
            ))}
            <br />
            {/* <HeroBanner /> */}
            <IndependenceDayOfferModal />
            <HeroBanner />
            {/* <HomeBanner/> */}
            <ExploreProgramHome />
            <OffersSection />
            <MostPopularCertificates />
            <TrendingSearches />
            {/* <TestimonialsCarousel /> */}
            {/* <FeaturedOn /> */}
            {/* <CourseList /> */}
            {/* <LearningBeyond /> */}
            {/* <GlobalReach /> */}
              {/* <ProgrammerStandOut /> */}
               {/* <Business /> */}
            
            {/* <Reviews /> */}
            {/* <NewOnSmiklearn /> */}
            {/* <AccessibilityFeature /> */}
            {/* <Partners /> */}
            {/* <TeacherFeature /> */}
            <Carousel showWriteReview={false} /> 
          </div>
        </div>
      </div>
    </main>
  );
}

export default HomePage;
